<template>
    <div class="manager_policy">
        <template v-if="selectedPost">
            <div class="title" >{{ selectedPost.title }}</div>
            <div class="ckeditor_view">
                <ckeditor :editor="editor" :disabled="editorDisabled" :model-value="editorData"></ckeditor>
            </div>
        </template>
    </div>
</template>
<script>
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
export default {
    name:'managerPolicy',
    props:[
        
    ],
    data(){
        return{
            selectedPost: null,
            editor:DecoupledEditor,
            editorData: '<p>매니져 정책</p>',
            editorDisabled: true,      
        }
    },
    mixins:[

    ],
    components:{

    },
    mounted() {
        this.getPost();       
    },
    methods:{
        async getPost(){
            try {
                let response='';
                //새로고침 했을때는 디비에서 값을 가져오게
                // if(this.$store.getters["posts/getposts"].data)
                // {
                    // response = await this.$store.getters["posts/getposts"].data.find(
                    // (post) => post.id === this.getId);
                // }else{
                    //로그인 유저아이디를 던져서 추천을 했는지 체크
                    const formData={
                        //user_id:1,
                        user_id:this.$store.getters.currentUser.id,
                        //post_id:this.id,
                        post_name:'partner'
                    }
                    response = await this.$store.dispatch("posts/getPost", formData)
                // }

                this.selectedPost = response.post;
                console.log('뷰포스트',response.post);
                this.updateViewer()
            }catch(error)
            {
                    console.log(error);
            }
        },
        updateViewer() {
            this.editorData =  this.selectedPost.content;
        },
    }
}
</script>
<style lang="scss" scoped>
.manager_policy{
    background: #fff;
    border: 1px solid #dee3eb;
    margin-bottom: 10px;
    padding:20px;
    font-family: nanumgothic;
    .title{        
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;
        text-align: center;
        border-bottom: 1px solid rgb(233, 233, 233);
        padding-bottom: 10px;
    }
}
</style>